export const en = {
    'two-fa-required-title': 'Two-factor authentication required',
    'two-fa-required-description':
        'For security reasons, two-factor authentication (2FA) is required for all developers of the Yandex Dialogs platform.',
    'two-fa-required-how-to': 'Please enable 2FA in your Yandex ID security settings, then refresh this page.',
    'two-fa-required-button': 'Enable 2FA in Yandex ID',
    'two-fa-required-button-yango': 'Enable 2FA in Yango ID',
    'two-fa-required-refresh': 'Refresh page',
    'two-fa-required-hint':
        'If you have already enabled 2FA but still see this page, try signing out and signing in again.',
} as const;

export const ru = {
    'two-fa-required-title': 'Нужна двухфакторная аутентификация',
    'two-fa-required-description':
        'В целях безопасности двухфакторная аутентификация (2FA) обязательна для всех разработчиков платформы Яндекс Диалогов.',
    'two-fa-required-how-to': 'Пожалуйста, включите 2FA в настройках безопасности Яндекс ID и обновите страницу.',
    'two-fa-required-button': 'Включить 2FA в Яндекс ID',
    'two-fa-required-button-yango': 'Включить 2FA в Yango ID',
    'two-fa-required-refresh': 'Обновить страницу',
    'two-fa-required-hint':
        'Если вы уже включили 2FA, но всё ещё видите эту страницу, попробуйте выйти и войти заново.',
} as const;
